<template>
  <div class="cbs-pay-pending-container">
    <div class="d-flex">
      <!-- 左侧项目筛选树 -->
      <div class="d-flex-left">
        <erp-tree @node-click="nodeClick"></erp-tree>
      </div>
      <!-- 右侧主内容区 -->
      <div class="d-flex-right">
        <!-- 筛选条件区域 -->
        <el-card class="filter-card">
          <el-form :inline="true" size="small">
            <el-form-item label="当前项目">
              <span style="font-weight: bold; color: #409eff;">{{ selectProject.house_name || '请选择项目' }}</span>
            </el-form-item>

            <el-form-item label="审核状态">
              <el-select
                v-model="queryParams.state"
                clearable
                placeholder="全部"
                style="width: 150px;">
                <el-option label="待确认" :value="0"></el-option>
                <el-option label="已通过" :value="1"></el-option>
                <el-option label="已驳回" :value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="提交日期">
              <el-date-picker
                v-model="queryParams.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 240px;">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="提交人">
              <el-input
                v-model="queryParams.submit_admin_name"
                placeholder="请输入提交人"
                clearable
                style="width: 150px;">
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="searchList" :loading="loading" :disabled="!selectProject.pindex_id">查询</el-button>
              <el-button @click="resetQuery">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 未选择项目时的提示 -->
        <el-card class="table-card" v-if="!selectProject.pindex_id">
          <div class="empty-tip">
            <i class="el-icon-info"></i>
            <span>请在左侧选择项目后再查询数据</span>
          </div>
        </el-card>

        <!-- 数据表格区域 -->
        <el-card class="table-card" v-else>
          <el-table
            :data="tableData"
            border
            stripe
            v-loading="loading"
            height="calc(100vh - 340px)"
            style="width: 100%">

            <el-table-column prop="id" label="ID" width="60"></el-table-column>
            <el-table-column label="账单类型" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ { deposit: '押金', temporary: '临时收费', advance: '预收款', order: '应收款' }[scope.row.order_type] || '其他' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="pay_total" label="收付总额" width="120" align="right">
              <template slot-scope="scope">
                <span style="font-weight: bold;">{{ scope.row.pay_total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="房产名称" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.house_info.ancestor_name || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="flow_ids" label="关联流水" width="100" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.flow_ids"
                  type="text"
                  size="mini"
                  style="color: #e6a23c;"
                  @click="viewFlowList(scope.row)">查看流水</el-button>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="state" label="状态" width="100" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.state === 0" type="warning" size="small">待确认</el-tag>
                <el-tag v-else-if="scope.row.state === 1" type="success" size="small">已通过</el-tag>
                <el-tag v-else-if="scope.row.state === 2" type="danger" size="small">已驳回</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="submit_admin_name" label="提交人" width="120"></el-table-column>
            <el-table-column prop="create_time" label="提交时间" width="170"></el-table-column>
            <el-table-column prop="review_admin_name" label="审核人" width="120">
              <template slot-scope="scope">
                {{ scope.row.review_admin_name || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="update_time" label="审核时间" width="170">
              <template slot-scope="scope">
                {{ scope.row.state !== 0 ? scope.row.update_time : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="review_remark" label="审核备注" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.review_remark || '-' }}
              </template>
            </el-table-column>

            <!-- 操作列 -->
            <el-table-column label="操作" fixed="right" width="240">
              <template slot-scope="scope">
                <el-button size="mini" type="info" @click="viewDetail(scope.row)">详情</el-button>
                <template v-if="scope.row.state === 0">
                  <el-button size="mini" type="success" @click="handleApprove(scope.row)">通过</el-button>
                  <el-button size="mini" type="danger" @click="handleReject(scope.row)">驳回</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <el-pagination
            @current-change="handlePageChange"
            :current-page.sync="pagination.page"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            layout="total, prev, pager, next, jumper"
            style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </div>
    </div>

    <!-- 详情弹框 -->
    <el-dialog
      title="待确认收付详情"
      :visible.sync="detailDialogVisible"
      width="80%"
      @close="closeDetailDialog">
      <div v-if="detailData" v-loading="detailLoading">
        <!-- 基本信息 -->
        <el-card class="detail-section" shadow="never">
          <div slot="header" class="section-header">基本信息</div>
          <el-descriptions :column="3" border size="small">
            <el-descriptions-item label="记录ID">{{ detailData.id }}</el-descriptions-item>
            <el-descriptions-item label="账单类型">
              <span>{{ { deposit: '押金', temporary: '临时收费', advance: '预收款', order: '应收款' }[detailData.order_type] || '其他' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="收付总额">
              <span style="font-weight: bold;">{{ detailData.pay_total }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="关联CBS流水">{{ detailData.flow_ids || '无' }}</el-descriptions-item>
            <el-descriptions-item label="审核状态">
              <el-tag v-if="detailData.state === 0" type="warning" size="small">待确认</el-tag>
              <el-tag v-else-if="detailData.state === 1" type="success" size="small">已通过</el-tag>
              <el-tag v-else-if="detailData.state === 2" type="danger" size="small">已驳回</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="提交人">{{ detailData.submit_admin_name }}</el-descriptions-item>
            <el-descriptions-item label="提交时间">{{ detailData.create_time }}</el-descriptions-item>
            <el-descriptions-item label="审核人">{{ detailData.review_admin_name || '-' }}</el-descriptions-item>
            <el-descriptions-item label="审核时间">{{ detailData.state !== 0 ? detailData.update_time : '-' }}</el-descriptions-item>
            <el-descriptions-item label="审核备注">{{ detailData.review_remark || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 账单明细 -->
        <el-card class="detail-section" shadow="never">
          <div slot="header" class="section-header">账单明细</div>
          <el-table
            :data="detailOrders"
            border
            size="small"
            style="width: 100%"
            max-height="400">
            <el-table-column label="项目名称" width="120" show-overflow-tooltip>
              <template>
                {{ detailData.pindex_info.name }}
              </template>
            </el-table-column>
            <el-table-column prop="h_name_date" label="房产地址" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="charge" label="应收金额" width="120" align="right"></el-table-column>
            <el-table-column prop="charge_money" label="实收金额" width="120" align="right"></el-table-column>
            <el-table-column prop="charge_sum" label="本期欠费" width="120" align="right"></el-table-column>
            <el-table-column prop="discount" label="减免" width="100" align="right"></el-table-column>
            <el-table-column prop="delayDiscount" label="滞纳金减免" width="120" align="right"></el-table-column>
            <el-table-column prop="chargeItem_name" label="费项名称" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="startDate" label="开始日期" width="120"></el-table-column>
            <el-table-column prop="endDate" label="结束日期" width="120"></el-table-column>
          </el-table>
        </el-card>

        <!-- 收付信息 -->
        <el-card class="detail-section" shadow="never">
          <div slot="header" class="section-header">收付信息</div>
          <el-descriptions :column="3" border size="small">
            <el-descriptions-item label="收付总额">{{ detailSubmitData.pay_total || '-' }}</el-descriptions-item>
            <el-descriptions-item label="缴费时间">{{ detailSubmitData.date || '-' }}</el-descriptions-item>
            <el-descriptions-item label="结算方式">{{ detailSubmitData.pay_name || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 关联流水信息 -->
        <el-card v-if="detailFlows.length > 0" class="detail-section" shadow="never">
          <div slot="header" class="section-header">关联银行流水信息</div>
          <el-table
            :data="detailFlows"
            border
            size="small"
            style="width: 100%"
            v-loading="detailFlowsLoading"
            max-height="400">
            <el-table-column prop="id" label="流水ID" width="80"></el-table-column>
            <el-table-column prop="transaction_date" label="交易时间" width="160"></el-table-column>
            <el-table-column prop="account_no" label="银行账号" width="180"></el-table-column>
            <el-table-column prop="opposite_name" label="对方户名" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="digest" label="摘要" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="发生额" width="120" align="right">
              <template slot-scope="scope">
                <span :class="scope.row.loan_type === '1' ? 'text-danger' : 'text-success'" style="font-weight: bold;">
                  {{ scope.row.incurred_amount }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="借贷" width="60" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.loan_type === '1' ? 'danger' : 'success'" size="mini">
                  {{ scope.row.loan_type === '1' ? '借' : '贷' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" fixed="right" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="viewFlowDetailFromDetail(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <div slot="footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 流水列表弹框 -->
    <el-dialog
      title="关联流水列表"
      :visible.sync="flowListDialogVisible"
      width="80%"
      @close="closeFlowListDialog">
      <el-table
        :data="flowListData"
        border
        size="small"
        v-loading="flowListLoading"
        max-height="500"
        style="width: 100%">
        <el-table-column prop="id" label="流水ID" width="80"></el-table-column>
        <el-table-column prop="transaction_date" label="交易时间" width="170"></el-table-column>
        <el-table-column prop="account_no" label="银行账号" width="200"></el-table-column>
        <el-table-column prop="opposite_name" label="对方户名" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="digest" label="摘要" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="发生额" width="130" align="right">
          <template slot-scope="scope">
            <span :class="scope.row.loan_type === '1' ? 'text-danger' : 'text-success'" style="font-weight: bold;">
              {{ scope.row.incurred_amount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="借贷" width="60" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.loan_type === '1' ? 'danger' : 'success'" size="mini">
              {{ scope.row.loan_type === '1' ? '借' : '贷' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="已勾兑" width="120" align="right">
          <template slot-scope="scope">{{ scope.row.reconciled_amount || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="viewFlowDetailFromList(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="flowListDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 驳回弹框 -->
    <el-dialog
      title="驳回原因"
      :visible.sync="rejectDialogVisible"
      width="500px"
      @close="rejectDialogVisible = false">
      <el-input
        v-model="rejectRemark"
        type="textarea"
        :rows="3"
        placeholder="请输入驳回原因（可选）">
      </el-input>
      <div slot="footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmReject" :loading="rejectLoading">确认驳回</el-button>
      </div>
    </el-dialog>

    <!-- 流水详情弹框 -->
    <cbs-flow-detail
      :visible.sync="flowDetailVisible"
      :flow-data="currentFlowRow"
      @close="flowDetailVisible = false">
    </cbs-flow-detail>
  </div>
</template>

<script>
import CbsFlowDetail from './order/CbsFlowDetail.vue';

export default {
  name: 'CbsPayPending',
  components: {
    CbsFlowDetail,
    'erp-tree': () => import('@/components/Admin/Common/erp-tree.vue')
  },
  data() {
    return {
      // 选中的项目
      selectProject: {
        pindex_id: 0,
        house_name: ''
      },

      // 查询参数
      queryParams: {
        state: '',
        dateRange: [],
        submit_admin_name: ''
      },

      // 表格数据
      tableData: [],
      loading: false,

      // 分页
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },

      // 详情弹框
      detailDialogVisible: false,
      detailLoading: false,
      detailData: null,
      detailSubmitData: {},
      detailOrders: [],

      // 驳回弹框
      rejectDialogVisible: false,
      rejectLoading: false,
      rejectRemark: '',
      rejectRow: null,

      // 流水数据
      detailFlows: [],
      detailFlowsLoading: false,
      flowDetailVisible: false,
      currentFlowRow: null,

      // 列表流水弹框
      flowListDialogVisible: false,
      flowListData: [],
      flowListLoading: false
    };
  },

  methods: {
    // 点击树节点
    nodeClick(data) {
      if (data.tree && data.tree.length > 0) {
        let treeData = data.tree[data.tree.length - 1];
        if (treeData.type === 'project') {
          this.selectProject.pindex_id = treeData.pindex_id;
          this.selectProject.house_name = treeData.name;
          // 选择项目后自动查询
          this.pagination.page = 1;
          this.searchList();
        }
      }
    },

    // 查询待确认列表
    searchList() {
      if (!this.selectProject.pindex_id) {
        this.$message.warning('请先在左侧选择项目');
        return;
      }

      this.loading = true;

      let startDate = undefined;
      let endDate = undefined;
      if (this.queryParams.dateRange && this.queryParams.dateRange.length === 2) {
        startDate = this.queryParams.dateRange[0];
        endDate = this.queryParams.dateRange[1];
      }

      const params = {
        pindex_id: this.selectProject.pindex_id,
        state: this.queryParams.state !== '' ? this.queryParams.state : undefined,
        start_date: startDate,
        end_date: endDate,
        submit_admin_name: this.queryParams.submit_admin_name || undefined,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      };

      this.$myhttp.post('admin/cbs/getPendingList', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.loading = false;
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || [];
          this.pagination.total = res.data.data.total || 0;

          if (this.tableData.length === 0) {
            this.$message.info('暂无数据');
          }
        } else {
          this.$message.error(res.data.message || '查询失败');
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },

    // 重置查询
    resetQuery() {
      this.queryParams = {
        state: '',
        dateRange: [],
        submit_admin_name: ''
      };
      this.pagination.page = 1;
      this.searchList();
    },

    // 分页切换
    handlePageChange(page) {
      this.pagination.page = page;
      this.searchList();
    },

    // 查看详情
    viewDetail(row) {
      this.detailData = null;
      this.detailSubmitData = {};
      this.detailOrders = [];
      this.detailFlows = [];
      this.detailDialogVisible = true;
      this.detailLoading = true;

      this.$myhttp.post('admin/cbs/getPendingDetail', { id: row.id }, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.detailLoading = false;
        if (res.data.code === 200) {
          this.detailData = res.data.data;
          this.detailSubmitData = res.data.data.submit_data_parsed || {};
          this.detailOrders = this.detailSubmitData.order || [];

          // 如果有关联流水ID，获取流水数据
          if (this.detailSubmitData.flow_ids) {
            this.fetchFlowData(this.detailSubmitData.flow_ids);
          }
        } else {
          this.$message.error(res.data.message || '查询失败');
        }
      }).catch(err => {
        this.detailLoading = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },

    // 获取关联流水数据
    fetchFlowData(flowIds) {
      this.detailFlowsLoading = true;
      const params = {
        flow_ids: flowIds
      };

      this.$myhttp.post('admin/cbs/getFlowByIds', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.detailFlowsLoading = false;
        if (res.data.code === 200) {
          this.detailFlows = res.data.data || [];
        }
      }).catch(err => {
        this.detailFlowsLoading = false;
        console.error('获取流水数据失败:', err);
      });
    },

    // 从详情的流水表格中查看流水明细
    viewFlowDetailFromDetail(row) {
      this.currentFlowRow = row;
      this.flowDetailVisible = true;
    },

    // 主列表查看流水（打开流水列表面板）
    viewFlowList(row) {
      if (!row.flow_ids) {
        this.$message.warning('该记录未关联流水');
        return;
      }
      this.flowListData = [];
      this.flowListDialogVisible = true;
      this.flowListLoading = true;

      const params = {
        flow_ids: row.flow_ids
      };

      this.$myhttp.post('admin/cbs/getFlowByIds', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.flowListLoading = false;
        if (res.data.code === 200) {
          this.flowListData = res.data.data || [];
        } else {
          this.$message.error(res.data.message || '查询流水失败');
        }
      }).catch(err => {
        this.flowListLoading = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },

    // 从流水列表中查看流水明细
    viewFlowDetailFromList(row) {
      this.currentFlowRow = row;
      this.flowDetailVisible = true;
    },

    // 关闭流水列表面板
    closeFlowListDialog() {
      this.flowListData = [];
    },

    // 关闭详情弹框
    closeDetailDialog() {
      this.detailData = null;
      this.detailSubmitData = {};
      this.detailOrders = [];
      this.detailFlows = [];
    },

    // 审核通过
    handleApprove(row) {
      this.$confirm('确认通过该收付申请？通过后将执行收付操作', '确认审核', {
        confirmButtonText: '确认通过',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doReview(row.id, 'approve', '');
      }).catch(() => {});
    },

    // 审核驳回（打开驳回弹框）
    handleReject(row) {
      this.rejectRow = row;
      this.rejectRemark = '';
      this.rejectDialogVisible = true;
    },

    // 确认驳回
    confirmReject() {
      this.rejectLoading = true;
      this.doReview(this.rejectRow.id, 'reject', this.rejectRemark);
    },

    // 执行审核
    doReview(id, action, reviewRemark) {
      const params = {
        id: id,
        action: action,
        review_remark: reviewRemark
      };

      this.$myhttp.post('admin/cbs/reviewPending', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.rejectLoading = false;
        this.rejectDialogVisible = false;

        if (res.data.code === 200) {
          this.$message.success(res.data.message || '操作成功');
          this.searchList(); // 刷新列表
        } else {
          this.$message.error(res.data.message || '操作失败');
        }
      }).catch(err => {
        this.rejectLoading = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.cbs-pay-pending-container {
  padding: 20px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
  width: 250px;
  min-height: calc(100vh - 140px);
}

.d-flex-right {
  flex: 1;
  overflow-x: hidden;
}

.filter-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: calc(100vh - 340px);
}

.empty-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #909399;
  font-size: 16px;
}

.empty-tip i {
  margin-right: 8px;
  font-size: 20px;
}

.detail-section {
  margin-bottom: 15px;
}

.section-header {
  font-weight: bold;
  font-size: 14px;
  color: #303133;
}

.text-success {
  color: #67c23a;
}

.text-danger {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/CbsPayPending.vue